
import procurement from '../../../Assets/Projects/Shot.png'
import hrm from '../../../Assets/Projects/hrm.png'

const projectList = [
    {
        imgPath: procurement,
        isBlog: false,
        title: "Procurement Approval",
        description: 'A robust mobile application designed to manage procurement requests efficiently, enabling users to submit, approve, reject, and track requests in real-time. The system ensures a fast, transparent, and fully paperless workflow by automating approval hierarchies, sending instant notifications, and maintaining an auditable history of every transaction. Ideal for organizations aiming to streamline procurement operations, reduce manual errors, and enhance overall accountability in purchasing decisions.',
        // ghLink: "https://github.com/roysuzon",
        // demoLink: "https://github.com/roysuzon",

    },
    {
        imgPath: hrm,
        isBlog: false,
        title: "HRM Attendance System – Smart Employee Attendance Tracking",
        description: 'A modern HRM Attendance application that simplifies employee attendance management through real-time tracking, automated check-ins/check-outs, leave monitoring, and detailed reporting. The system ensures accurate attendance records, enhances workforce accountability, and integrates seamlessly with HR operations — perfect for both remote and in-office teams.',
        // ghLink: "https://github.com/roysuzon",
        // demoLink: "https://github.com/roysuzon",

    }
]

export default projectList;